<template>
    <div class='blank'>
      <img :src="backgroundImage" alt="">
      <p>暂无内容</p>
    </div>
</template>

<script>
    import contentImg from '../../utils/image'
    export default {
        name: "",
        data() {
            return {
              backgroundImage:''
            }
        },
      created(){
        const randIndex = Math.floor(Math.random() * contentImg.length)
        this.backgroundImage= contentImg[randIndex]
      }
    }
</script>

<style scoped lang='less'>
.blank{
    min-width: 300px;
    min-height:600px ;
    background-color: #FFFFFF;
    border-radius: 6px;
    overflow: hidden;
  img{
      width: 119px;
      height: 128px;
      margin: 200px auto 0;
  }
  p{
    text-align: center;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/blank.vue